import { makeStyles } from '@material-ui/styles'

import { Theme } from 'styling/theme'

export const useStyles = makeStyles((theme: Theme) => ({
    paywallWrapper: {
        background: theme.colors.white,
        top: 0,
        position: 'absolute',
        bottom: '0',
        width: '100%',
        padding: '20px 16px',
        textAlign: 'center',
        zIndex: theme.zIndexLevels.five,
        minHeight: 580,
    },
    '@media (min-width: 768px)': {
        paywallWrapper: {
            overflow: 'auto',
        },
    },
    '@media (max-width: 767px)': {
        paywallWrapper: {
            padding: '40px 16px 20px',
        },
    },
}))
